/**=========================================================
 * Module: language.js
 * Language Controller
 =========================================================*/

App.controller('LanguageController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) {
    "use strict";
     
    $scope.type = 'language';
    $scope.filter = '';
    
    $scope.data = [];
    
    $scope.page = {
            title: 'labels.LANGUAGES',
            subTitle: ''
        };
      
    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){  
      
        if($rootScope.user.id){
            $scope.initialized = true;
            
            $scope.table = {
                title: '',
                fields: [
                    {
                    	available: true,
                        name: 'code'
                    },{
                    	available: true,
                        name: 'code',
                        type: 'enum',
                        label: 'name',
                        enumType: 'language'
                    }
                ],
                loading: true
            };
            D.query('language','').then(function(response){
                $scope.data = response.sort(function(a, b){
                    return a.code.localeCompare(b.code);
                });
            })

            $scope.tablem = {
                title: '',
                fields: [
                    {
                    	available: true,
                        name: 'code'
                    },{
                    	available: true,
                        name: 'lang',
                        label: 'LANGUAGE'
                    },{
                    	available: true,
                        name: 'lang',
                        type: 'enum',
                        label: 'name',
                        enumType: 'language'
                    }
                ],
                loading: true
            };
            D.query('languagecode','').then(function(response){
                $scope.datam = response.sort(function(a, b){
                    return a.code.localeCompare(b.code);
                });
            })

            
        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }
    
    $scope.init();
      
}]);